import React, { useContext, useState } from "react";
import { css } from "emotion";
import { textSizes, boxStyles } from "../styles/theme";

import { EditContext } from "../context/EditSpotlightState";

const PreviewBanner = ({ style }) => {
  const {
    headline,
    ctaText,
    ctaLink,
    primaryColor,
    secondaryColor,
    type,
    fileUrl,
    showCta,
  } = useContext(EditContext);

  // console.log('TYPE:', type);

  const [isPaused, setIsPaused] = useState(true);

  let _audio;

  const handlePlayPause = () => {
    if (isPaused) {
      const allAudio = document.getElementsByTagName("audio");
      for (let i = 0; i < allAudio.length; i++) {
        allAudio[i].pause();
      }

      _audio.play();
      setIsPaused(false);
    } else {
      _audio.pause();
      setIsPaused(true);
    }
  };

  return (
    <div
      className={`${style ? style : ""} ` + container}
      style={{ backgroundColor: primaryColor }}
    >
      {type === "text" ? (
        <div className="spotlt_container">
          <div className="spotlt_content">
            <p className="spotlt_text" style={{ color: secondaryColor }}>
              {headline ||
                "See why Slack is better than Microsoft Teams 100% of the time"}
            </p>
            <a
              target="_blank"
              href={ctaLink || "https://"}
              className={"spotlt_button" + (isPaused ? "" : " pause")}
              style={{
                borderColor: secondaryColor,
                color: secondaryColor,
                display: showCta ? "flex" : "none",
              }}
            >
              {ctaText || "CONTACT US"}
            </a>
          </div>
        </div>
      ) : (
        <div className="spotlt_container">
          <div className="spotlt_content">
            <p className="spotlt_text" style={{ color: secondaryColor }}>
              {headline ||
                "See why Slack is better than Microsoft Teams 100% of the time"}
            </p>
            <a
              onClick={handlePlayPause}
              className={"spotlt_button" + (isPaused ? "" : " pause")}
              style={{ borderColor: secondaryColor, color: secondaryColor }}
            >
              {isPaused ? "LISTEN" : "PAUSE"}
              <div
                className="spotlt_play-icon-circle"
                style={{
                  display: "inline-block",
                  backgroundColor: secondaryColor,
                }}
              >
                <div
                  className="spotlt_icon"
                  style={{
                    borderColor: `transparent transparent transparent ${primaryColor}`,
                  }}
                />
              </div>
              <audio
                src={fileUrl}
                ref={(element) => (_audio = element)}
                onEnded={() => setIsPaused(true)}
              />
            </a>
          </div>
        </div>
      )}
    </div>
  );
};

const container = css`
  display: flex;
  width: 100%;

  .spotlt_container {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 45px;
    color: rgb(255, 255, 255);
    width: 100%;
    padding: 2px 12px;

    .spotlt_content {
      display: flex;
      max-width: 800px;
      justify-content: center;
      align-content: center;
      width: 100%;

      p {
        align-self: center;
        font-weight: 400;
        color: rgb(255, 255, 255);
        line-height: 14px;
        margin: 0;
        font-size: 12px;
        flex: 1 1 0%;
      }

      a {
        text-decoration: none;
      }
    }
  }

  .spotlt_button {
    background-color: transparent;
    cursor: pointer;
    margin-left: 30px;
    font-weight: bold;
    font-size: 16px;
    letter-spacing: 1.33px;
    display: flex;
    align-items: center;
    height: 35px;
    align-self: center;
    min-width: 60px;
    color: rgb(255, 255, 255);
    border-radius: 3px;
    padding: 3px 18px;
    border-width: 2px;
    border-style: solid;
    border-color: rgb(255, 255, 255);
    border-image: initial;
    min-width: 98px;
    justify-content: center;
    box-sizing: border-box;
    font-size: 11px;
    padding: 0px 6px;
    margin-left: 10px;
    height: 28px;
    flex-shrink: 1;
    text-transform: uppercase;

    .spotlt_play-icon-circle {
      display: inline-block;
      height: 18px;
      width: 18px;
      margin-left: 8px;
      position: relative;
      transition-duration: 0.2s;
      border-radius: 50%;

      .spotlt_icon {
        display: block;
        will-change: border-width;
        cursor: pointer;
        left: 6px;
        position: absolute;
        top: 4px;
        transition: all 0.2s ease 0s;
        border-style: solid;
        border-width: 5px 0px 5px 8px;
      }
    }

    &.pause {
      .spotlt_icon {
        height: 10px;
        transform: translateX(-1px);
        border-style: double;
        border-width: 0px 0px 0px 8px;
      }
    }
  }

  .innerBox {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: ${boxStyles.standardPadding};
    .headline-container {
      max-width: 70%;
      p {
        font-size: ${textSizes.normal};
      }
    }

    button {
      background-color: transparent;
      border: none;
      width: 100%;
      display: flex;
      justify-content: center;
      padding: 0;
    }
  }

  .widget-button {
    min-width: 100px;
    padding: 12px 0;
  }

  @media screen and (min-width: ${boxStyles.desktopBreak}) {
    .spotlt_container {
      .spotlt_content {
        .spotlt_text {
          font-size: 14px;
          flex: 0 0 auto;
        }

        .spotlt_button {
          font-size: 13px;
          padding: 1px 12px;
          margin-left: 24px;
          height: 30px;
          min-width: 108px;
        }
      }
    }

    .innerBox {
      padding: ${boxStyles.desktopPadding};
      .headline-container {
        width: 100%;
        max-width: 100%;
        p {
          text-align: center;
          font-size: ${textSizes.intermediate};
        }
      }
    }
  }
`;

export default PreviewBanner;
